import type { JobItemResultFragment, Maybe } from '@/graphql/generated';

import type { JobItemResultFragmentWithVisibleJob } from '../types';

export const isVisibleJob = (item: Maybe<JobItemResultFragment>): item is JobItemResultFragmentWithVisibleJob => {
  return item?.jobDetail?.__typename === 'VisibleJob';
};
